import { render } from "./AcceptCookies.vue?vue&type=template&id=a0a99fc4"
import script from "./AcceptCookies.vue?vue&type=script&lang=js"
export * from "./AcceptCookies.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__